import React from 'react';
import { Form, Formik } from 'formik';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';

import { Header } from 'widget/components';
import { parseFromLocalStorage, putInLocalStorage } from 'widget/actions';
import { useWidgetContext } from 'widget/widget-context';
import * as Env from 'widget/env';

import Email from './email/email';
import Name from './name/name';
import Phone from './phone/phone';
import Submit from './submit/submit';

interface GuestForm {
  createAccessToken: (guest?: Env.Guest) => Promise<string | null>;
  openWs: (accessToken: string) => Promise<unknown>;
}

interface Values extends Env.Guest {
  is_email: boolean;
  is_name: boolean;
  is_phone: boolean;
  phone: string;
}

const GuestForm = ({ createAccessToken, openWs }: GuestForm) => {
  const { widget } = useWidgetContext();
  const { t } = useTranslation();

  const handleSubmit = async (values: Env.Guest) => {
    const res = await createAccessToken(values);
    if (!res) return true;

    openWs(res);
    putInLocalStorage('whatcrmWidgetGuest', JSON.stringify(values));

    return true;
  };

  const guest = parseFromLocalStorage<Partial<Env.Guest>>('whatcrmWidgetGuest');

  const initialValues: Values = {
    email: '',
    is_email: widget.is_email,
    is_name: widget.is_name,
    is_phone: widget.is_phone,
    name: guest?.name ?? '',
    phone: guest?.phone ?? '',
  };

  const validationSchema = yup.object().shape({
    email: yup
      .string()
      .when('is_email', { is: true, then: schema => schema.trim().required() }),
    name: yup
      .string()
      .when('is_name', { is: true, then: schema => schema.trim().required() }),
    phone: yup
      .string()
      .when('is_phone', { is: true, then: schema => schema.trim().required() }),
  });

  return (
    <div className="whatcrm-widget-guest-form">
      <div className="whatcrm-widget-guest-form__window">
        <Header.H3 style={{ marginBottom: 16 }}>
          {t`How may we address you?`}
        </Header.H3>

        <Formik
          initialValues={initialValues}
          onSubmit={handleSubmit}
          validateOnBlur={false}
          validationSchema={validationSchema}
        >
          <Form>
            <Name />
            <Email />
            <Phone />
            <Submit />
          </Form>
        </Formik>
      </div>
    </div>
  );
};

export default GuestForm;
